import type { IErrorJumio } from '../types/jumio.type';

export const ErrorsJumio: IErrorJumio = {
  IDENTITY_VERIFICATION_FAILED: 'Error al verificar la identidad',
  DOCUMENT_TYPE_NOT_MATCH:
    'El tipo de documento no coincide con el utilizado en la validación biométrica',
} as const;
